import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { IoClose } from "react-icons/io5";
import { RxHamburgerMenu } from "react-icons/rx";
import logo from "../assets/logo/CIG_2601_Logo-01.png";
import { MdAccountCircle } from "react-icons/md";


export default function NavbarGold() {
    const [isVisible, setIsVisible] = useState(true);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [menuTransition, setMenuTransition] = useState(false);
    const [hideLink, setHideLink] = useState(false);


    const location = useLocation();
    const isActive = (path) => location.pathname === path;

    const lastScrollY = useRef(window.scrollY);


    useEffect(() => {
        const handleScroll = () => { 
            if (!isMenuOpen) {
                setIsVisible(window.scrollY < lastScrollY.current);
                lastScrollY.current = window.scrollY;
            }
            if (window.scrollY < 800) {
                setIsVisible(true);
            }
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, [isMenuOpen]);

    useEffect(() => {
        if(!window.lenis) return;

        if (isMenuOpen) {
            window.lenis?.stop();
            document.body.style.overflow = "hidden";

        } else {
            window.lenis?.start();
            document.body.style.overflow = "";
        }
    }, [isMenuOpen]);


    const handleMenuOpen = () => {
        setIsMenuOpen(true);
        setHideLink(false);

        setTimeout(() => {
            setMenuTransition(true);
        }, 1000);
    };

    const handleMenuClose = () => {
        setHideLink(true);

        setTimeout(() => {
            setMenuTransition(false);
            setIsMenuOpen(false);
        }, 900);
    };
    
    
    return (
        <>
        <nav aria-label="Navigazione principale" className="relative">
            
            <div className={`fixed top-0 left-0 w-full z-50 transition-transform duration-300 ease-in-out
                ${isVisible ? 'translate-y-0' : '-translate-y-full'}`}>
         
                <div className={`fixed top-0 left-0 z-40 p-5 pt-7 transition-transform duration-300 ease-in-out ${isVisible ? 'translate-y-0' : '-translate-y-full'}`}>
                    <Link to="/" aria-label="Vai alla homepage di Careisgold">
                        <img src={logo} className="w-32 md:w-56" />
                    </Link>
                </div>

                {/* Desktop Menu */}
                <div className={`hidden lg:block fixed top-0 right-0 z-40 xl:m-7 mt-10 mr-7 xl:px-7 xl:py-3 px-5 py-2 rounded-full bg-[#b7955a] transition-transform duration-300 ease-in-out 
                ${isVisible ? 'translate-y-0' : '-translate-y-[200%]'}`}>
                    <ul className={`flex justify-center gap-6 items-center text-sm xl:text-base`}
                        role="navigation" aria-label="Menu di navigazione principale">
                        <li>
                            <Link
                                to="/"
                                aria-current={isActive("/") ? "page" : undefined}
                                className={`uppercase ${isActive('/') ? 'underline-animate-pill-active text-white' : 'underline-animate-pill'}`}
                            >
                                Home
                            </Link>
                        </li>

                        <li>
                            <Link
                                to="/azienda/"
                                aria-current={isActive("/azienda/") ? "page" : undefined}
                                className={`uppercase ${isActive('/azienda/') ? 'underline-animate-pill-active text-white' : 'underline-animate-pill'}`}
                            >
                                Azienda
                            </Link>
                        </li>

                        <li>
                            <Link
                                to="/prodotti-e-servizi/"
                                aria-current={isActive("/prodotti-e-servizi/") ? "page" : undefined}
                                className={`uppercase ${isActive('/prodotti-e-servizi/') ? 'underline-animate-pill-active text-white' : 'underline-animate-pill'}`}
                            >
                                Prodotti
                            </Link>
                        </li>

                        <li>
                            <Link
                                to="/notizie/?section=approfondimenti"
                                aria-current={isActive("/notizie/") ? "page" : undefined}
                                className={`uppercase ${isActive('/notizie/') ? 'underline-animate-pill-active text-white' : 'underline-animate-pill'}`}
                            >
                                Notizie
                            </Link>
                        </li>

                        <li>
                            <Link
                                to="/collabora-con-noi/"
                                aria-current={isActive("/collabora-con-noi/") ? "page" : undefined}
                                className={`uppercase ${isActive('/collabora-con-noi/') ? 'underline-animate-pill-active text-white' : 'underline-animate-pill'}`}
                            >
                                Collabora con noi
                            </Link>
                        </li>

                        <li>
                            <Link
                                to="/faq/"
                                aria-current={isActive("/faq/") ? "page" : undefined}
                                className={`uppercase ${isActive('/faq/') ? 'underline-animate-pill-active text-white' : 'underline-animate-pill'}`}
                            >
                                FAQ
                            </Link>
                        </li>

                        <li>
                            <Link
                                to="/contatti/"
                                aria-current={isActive("/contatti/") ? "page" : undefined}
                                className={`uppercase ${isActive('/contatti/') ? 'underline-animate-pill-active text-white' : 'underline-animate-pill'}`}
                            >
                                Contatti
                            </Link>
                        </li>
                        <li>
                            <Link 
                                aria-current={isActive("/area-clienti-collaboratori/") ? "page" : undefined}
                                to="/area-clienti-collaboratori/"
                            >
                                <MdAccountCircle className={`hover:text-white text-3xl ${isActive('/area-clienti-collaboratori/') ? 'text-white' : ''}`}  />
                            </Link>
                        </li>
                    </ul>
                </div>
            
                {/**menu mobile */}
                <div className="block lg:hidden w-full">
                    <div className={`fixed top-0 right-0 z-40 p-5 pt-7 transition-transform duration-300 ease-in-out
                        ${isVisible ? 'translate-y-0' : '-translate-y-full'}`}>
                            <button
                                type="button"
                                className="w-6 h-6"
                                onClick={handleMenuOpen}
                                aria-label="Apri il menu di navigazione"
                                aria-expanded={isMenuOpen}
                                aria-controls="mobile-menu"
                            >
                                <RxHamburgerMenu className="text-3xl text-gold" aria-hidden="true" focusable="false" />
                            </button>
                    </div>

                    <div
                        id="mobile-menu"
                        aria-label="Menu di navigazione mobile"
                        className={`z-50 flex flex-col justify-center fixed top-0 inset-0 bg-black items-center w-full h-lvh transition-all duration-[1000ms] ease-in-out
                        ${isMenuOpen ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-full'}`}
                        onClick={(e) => {
                            if (e.target.closest("a")) {
                                handleMenuClose();
                            }
                        }}>
                        {menuTransition && (
                            <>
                                <ul className="flex flex-col mini-screen:gap-1 gap-4 justify-center items-center w-full">
                                    <li>
                                        <Link
                                            to="/"
                                            aria-current={isActive("/") ? "page" : undefined}
                                            {...(window.innerWidth > 320 && window.innerHeight > 256
                                                ? { "data-aos": "fade-right", "data-aos-duration": "250" }
                                                : {})}
                                            className={`${hideLink ? 'link-hidden' : ''} mini-screen:text-xs text-slate-50 uppercase ${isActive('/') ? 'text-gold' : ''}`}
                                            >
                                            Home
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="/azienda/"
                                            aria-current={isActive("/azienda/") ? "page" : undefined}
                                            {...(window.innerWidth > 320 && window.innerHeight > 256
                                                ? { "data-aos": "fade-right", "data-aos-duration": "500" }
                                                : {})}
                                            className={`${hideLink ? 'link-hidden' : ''} mini-screen:text-xs text-slate-50 uppercase ${isActive('/azienda/') ? 'text-gold' : ''}`}
                                        >
                                            Azienda
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="/prodotti-e-servizi/"
                                            aria-current={isActive("/prodotti-e-servizi/") ? "page" : undefined}
                                            {...(window.innerWidth > 320 && window.innerHeight > 256
                                                ? { "data-aos": "fade-right", "data-aos-duration": "750" }
                                                : {})}
                                            className={`${hideLink ? 'link-hidden' : ''} mini-screen:text-xs text-slate-50 uppercase ${isActive('/prodotti-e-servizi/') ? 'text-gold' : ''}`}
                                        >
                                            Prodotti
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="/notizie/?section=approfondimenti"
                                            aria-current={isActive("/notizie/") ? "page" : undefined}
                                            {...(window.innerWidth > 320 && window.innerHeight > 256
                                                ? { "data-aos": "fade-right", "data-aos-duration": "1000" }
                                                : {})}
                                            className={`${hideLink ? 'link-hidden' : ''} mini-screen:text-xs text-slate-50 uppercase ${isActive('/notizie/') ? 'text-gold' : ''}`}
                                        >
                                            Notizie
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="/collabora-con-noi/"
                                            aria-current={isActive("/collabora-con-noi/") ? "page" : undefined}
                                            {...(window.innerWidth > 320 && window.innerHeight > 256
                                                ? { "data-aos": "fade-right", "data-aos-duration": "1250" }
                                                : {})}
                                            className={`${hideLink ? 'link-hidden' : ''} mini-screen:text-xs text-slate-50 uppercase ${isActive('/collabora-con-noi/') ? 'text-gold' : ''}`}
                                        >
                                            Collabora con noi
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="/faq/"
                                            aria-current={isActive("/faq/") ? "page" : undefined}
                                            {...(window.innerWidth > 320 && window.innerHeight > 256
                                                ? { "data-aos": "fade-right", "data-aos-duration": "1500" }
                                                : {})}
                                            className={`${hideLink ? 'link-hidden' : ''} mini-screen:text-xs text-slate-50 uppercase ${isActive('/faq/') ? 'text-gold' : ''}`}
                                        >
                                            FAQ
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="/contatti/"
                                            aria-current={isActive("/contatti/") ? "page" : undefined}
                                            {...(window.innerWidth > 320 && window.innerHeight > 256
                                                ? { "data-aos": "fade-right", "data-aos-duration": "1750" }
                                                : {})}
                                            className={`${hideLink ? 'link-hidden' : ''} mini-screen:text-xs text-slate-50 uppercase ${isActive('/contatti/') ? 'text-gold' : ''}`}
                                        >
                                            Contatti
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="/area-clienti-collaboratori/"
                                            aria-current={isActive("/area-clienti-collaboratori/") ? "page" : undefined}
                                            {...(window.innerWidth > 320 && window.innerHeight > 256
                                                ? { "data-aos": "fade-right", "data-aos-duration": "2000" }
                                                : {})}
                                            className={`${hideLink ? 'link-hidden' : ''} mini-screen:text-xs text-slate-50 uppercase ${isActive('/area-clienti-collaboratori/') ? 'text-gold' : ''}`}
                                            >
                                            Login
                                        </Link>
                                    </li>
                                </ul>

                                <button
                                    type="button"
                                    className="absolute top-0 right-0 m-5 w-6 h-6"
                                    onClick={handleMenuClose}
                                    aria-label="Chiudi il menu di navigazione"
                                >
                                    <IoClose className="text-3xl text-gold" aria-hidden="true" focusable="false" />
                                </button>

                            </>
                        )}
                    </div>
                </div>
            </div>
            
        </nav>
        </>
    );
}